/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Search_Text_LabelInputs */



/**
* | output |
* | --- |
* | "Search Text" |
*
* @param {Editor_Search_Text_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_search_text_label = /** @type {((inputs?: Editor_Search_Text_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Search_Text_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rechercher du texte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Suchbegriff")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cerca testo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Поиск текста")
	if (locale === "es") return /** @type {LocalizedString} */ ("Buscar texto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("搜索文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("検索テキスト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खोज पाठ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Texto de pesquisa")
	return /** @type {LocalizedString} */ ("Search Text")
});